import { EventEmitter, Output } from "@angular/core";
import { TrendClass } from "./subscription/subscription.data";

export abstract class DashboardTabAbstractComponent {
  @Output() excludeAbandonsChange = new EventEmitter<boolean>();

  excludeAbandons: boolean = false;

  getTrendClass(isNegative: boolean): TrendClass {
    let trendClass = TrendClass.Positive;
    if (isNegative) {
      trendClass = TrendClass.Negative;
    }
    return trendClass;
  }

  onExcludeAbandonsChange(value: boolean) {
    this.excludeAbandons = value;
    this.excludeAbandonsChange.emit(value);
  }
}
